/**
 * BookIcon/index.js
 * desc: book icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const BookIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="book icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.book.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 22 17" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 0c1.17 0 2.39.15 3.5.5.75.25 1.4.55 2 1v14.6c0 .25-.25.5-.5.5-.1 0-.15 0-.25-.05-1.4-.75-3.1-1.05-4.75-1.05-1.7 0-4.15.65-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5-1.45 0-3.4.45-4.75 1.1-.05 0-.088.012-.125.025-.037.012-.075.025-.125.025-.25 0-.5-.25-.5-.5V1.5C1.45.4 3.55 0 5.5 0 7.45 0 9.55.4 11 1.5 12.45.4 14.55 0 16.5 0zm0 13.5c1.2 0 2.4.15 3.5.5V2.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V15c1.35-.85 3.8-1.5 5.5-1.5z" /></svg>
    </IconButton>
);


export default BookIcon;
